var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaSparkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.4974V20.9974C24 24.2972 24 25.9471 22.9749 26.9723C21.9497 27.9974 20.2998 27.9974 17 27.9974C13.7002 27.9974 12.0502 27.9974 11.0251 26.9723C10 25.9471 10 24.2972 10 20.9974V14.9974C10 11.6976 10 10.0476 11.0251 9.02251C11.8815 8.16613 13.1739 8.02516 15.5 8.00195H20",
    stroke: "#CC9C2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 7L24.3837 8.70793C24.7101 10.1566 25.8414 11.288 27.2901 11.6143L28.998 11.999L27.2901 12.3838C25.8414 12.7101 24.7101 13.8414 24.3837 15.2901L23.999 16.998L23.6143 15.2901C23.2879 13.8414 22.1567 12.7101 20.708 12.3838L19 11.999L20.708 11.6143C22.1566 11.288 23.2879 10.1566 23.6143 8.70794L23.999 7Z",
    stroke: "#CC9C2F",
    strokeWidth: 1.07122,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.998H18",
    stroke: "#CC9C2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaSparkIcon);
export default __webpack_public_path__ + "static/media/triva_spark-icon.f2c6c3209d2faf0bef5bdc513565732d.svg";
export { ForwardRef as ReactComponent };